import { render, staticRenderFns } from "./HcViewEditRecord.vue?vue&type=template&id=9c24016c&"
import script from "./HcViewEditRecord.vue?vue&type=script&lang=js&"
export * from "./HcViewEditRecord.vue?vue&type=script&lang=js&"
import style0 from "./HcViewEditRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports